import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import PageBuilder from '../../components/admin/PageBuilder';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';

const AdminPageBuilderPage = () => {
  const { user, isAuthenticated } = useAuth();

  // Check if user is admin
  if (!isAuthenticated || (user?.role !== 'admin' && user?.role !== 'sub_admin')) {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      <div className="page-transition">
        <PageBuilder />
      </div>
    </Layout>
  );
};

export default AdminPageBuilderPage;
